import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { i18n } from './i18n'
import App from './App.vue'
import {createPinia} from 'pinia'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(vuetify)
app.use(router)
app.use(i18n)
app.mount('#app')
